import './processPolyfill';
import './index.scss';
import '@spotted-zebra-uk/ui-components/dist/sz-theme/_globalStyles.scss';
import './helpers/il8n';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { setDocumentHeadLinks } from './helpers/setDocumentHeadLinks';

setDocumentHeadLinks();

const container = document.getElementById('app');
const root = createRoot(container as HTMLElement);
root.render(
  <Suspense fallback="Loading...">
    <App />
  </Suspense>
);
